import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WorkItemModel } from '../../../models/work-item';
import { FileUploadModel } from '../../../models/file-upload.model';

@Component({
    selector: 'e5core-ui-file-upload-prime',
    templateUrl: './e5core-ui-file-upload-prime.component.html',
    styleUrls: ['./e5core-ui-file-upload-prime.component.css']
  })
  export class E5coreUiFileUploadPrimeComponent implements OnInit{

    @Input() workItem$: BehaviorSubject<WorkItemModel>;
    @Input() fileUpload$: BehaviorSubject<FileUploadModel>;
    @Input() uploadToUrl: string;
    @Input() acceptedFileExtensions: string;
    @Input() maxFileSize: string;
    @Input() readOnly: boolean;

    @Output() uploadEvent = new EventEmitter();

    uploadedFiles: any[] = [];

    constructor() {
    }

    ngOnInit() {
    }

    onBeforeUpload(event) {
    }
  
    onUploadSuccess(event) {
      this.uploadEvent.emit(event);

      this.workItem$.next(this.workItem$.getValue());
      this.fileUpload$.next(this.fileUpload$.getValue());
    }
  
    onUploadError(event) {
      this.uploadEvent.emit(event);
    }
}